import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=09aa2a63&scoped=true&"
import script from "./ResultList.vue?vue&type=script&lang=js&"
export * from "./ResultList.vue?vue&type=script&lang=js&"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=09aa2a63&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aa2a63",
  null
  
)

export default component.exports